import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteWorkoutPlan,
  fetchWorkoutPlan,
  postWorkoutPlan,
} from "../../api/workoutPlanApi";
import * as Endpoints from "../../entities/Endpoints";

export const fetchWorkoutPlanThunk = createAsyncThunk(
  Endpoints.GET_WORKOUT_PLAN,
  async ({ clientId, coachId, coachWorkoutPlanId }, { rejectWithValue }) => {
    try {
      const data = await fetchWorkoutPlan({
        clientId,
        coachId,
        coachWorkoutPlanId,
      });

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteWorkoutPlanThunk = createAsyncThunk(
  Endpoints.DELETE_WORKOUT_PLAN,
  async ({ clientId, coachWorkoutPlanId }, { rejectWithValue }) => {
    try {
      const data = await deleteWorkoutPlan({
        clientId,
        coachWorkoutPlanId,
      });

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const postWorkoutApi = createAsyncThunk(
  Endpoints.POST_WORKOUT_PLAN,
  async (payload, { rejectWithValue }) => {
    try {
      const data = await postWorkoutPlan({ payload });

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const workoutPlanSlice = createSlice({
  name: "getWorkoutPlan",
  initialState: {
    workoutPlan: null,
    isloading: false,
    error: null,
    successMessage: null,
    updateSuccessMessage: "",
    updateFailedMessage: "",
  },
  reducers: {
    clearUpdateMessage: (state) => {
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkoutPlanThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(fetchWorkoutPlanThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.workoutPlan = action.payload;
      })
      .addCase(fetchWorkoutPlanThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
      })

      .addCase(deleteWorkoutPlanThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(deleteWorkoutPlanThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.updateSuccessMessage = action?.payload?.message;
      })
      .addCase(deleteWorkoutPlanThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
      })

      .addCase(postWorkoutApi.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(postWorkoutApi.fulfilled, (state, action) => {
        state.isloading = false;
        state.workoutPlan = action.payload;
        state.updateSuccessMessage = action?.payload?.message;
      })
      .addCase(postWorkoutApi.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
        state.updateFailedMessage = action.payload?.message;
      });
  },
});

export const { clearUpdateMessage } = workoutPlanSlice.actions;

export const WorkoutPlanReducer = workoutPlanSlice.reducer;
